module.exports = __webpack_public_path__ + "officialStatic/img/detail-self4.899ffc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/detail-self4.png
// module id = 4wRz
// module chunks = 0